import React, { ReactNode } from 'react'

export const HeaderCol = ({ children }: { children: ReactNode }) => {
  return <div className="px-2 py-1">{children}</div>
}
